<template>
<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-markdown`]" width="1em" height="1em" v-bind="$attrs"><path d="M12.21 1C12.3956 1 12.5738 1.0738 12.7051 1.20508L16.7949 5.29492C16.9262 5.4262 17 5.60439 17 5.79004V18.2998C17 18.6864 16.6864 19 16.2998 19H3.7002C3.3136 19 3 18.6864 3 18.2998V1.7002C3 1.3136 3.3136 1 3.7002 1H12.21ZM6.92969 9.53711C6.76417 9.53728 6.62992 9.67137 6.62988 9.83691V15.6631C6.62994 15.8286 6.76418 15.9627 6.92969 15.9629H7.38281C7.54846 15.9629 7.68256 15.8287 7.68262 15.6631V11.5352H7.71875L9.53125 15.7803C9.57842 15.8908 9.68745 15.9629 9.80762 15.9629H10.3203C10.4403 15.9627 10.5486 15.8907 10.5957 15.7803L12.4082 11.5352H12.4443V15.6631C12.4444 15.8287 12.5785 15.9629 12.7441 15.9629H13.1973C13.3628 15.9627 13.497 15.8286 13.4971 15.6631V9.83691C13.497 9.67135 13.3628 9.53725 13.1973 9.53711H12.4609C12.3414 9.5372 12.233 9.60803 12.1855 9.71777L10.0859 14.5771H10.0498L7.94141 9.71777C7.89383 9.60813 7.78553 9.53711 7.66602 9.53711H6.92969ZM12 6.5H16L12 2.5V6.5Z" :fill="useCurrentColor ? 'currentColor' : '#9B59F7'"/></svg>
</template>
<script>

export default {
  name: 'IconColorMarkdown',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
